import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Rx';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { AuthHttp, AuthConfig } from 'angular2-jwt';

import * as globals from '../globals';

@Injectable()
export class UploadModelService {


    private projectsUrl = globals.APIURL + '/projects';
    private processUrl = this.projectsUrl + '/process';
    private processStatusUrl = this.processUrl + '/status';
    constructor(private http: Http, public authHttp: AuthHttp) { }


    addModelWorkspace(file: Array<File>, type: number, modeldetails: any): Observable<string> {
        console.log('uploadWorkspace model service method called');
        console.log('Models name  : ' + modeldetails.projectname);
        console.log('File array count:', file.length);
        let body;
        let filenamenoext = file[0].name.replace(/\.[^/.]+$/, '');
        body = JSON.stringify({
          project: {
            name: filenamenoext,
            file_size: file[0].size,
            filename: file[0].name,
            modeltype_id: type,
            enabled: 1,
            type: 1
          }
        });

        let headers = new Headers({
          'Content-Type': 'application/json'
        });
        let options = new RequestOptions({ headers: headers });

        return this.authHttp.post(this.projectsUrl, body, options)
          .map(this.extractData)
          .catch(this.handleError);
      }

    startProcessingUpload(projectid: string, tenantid: string, filename: string, planid: string): Observable<string> {
        console.log('startProcessing service method called');

        let body = JSON.stringify({ projectid: projectid, tenantid: tenantid, filename: filename, planid: planid });
        let headers = new Headers({
            'Content-Type': 'application/json'
        });
        let options = new RequestOptions({ body: body, headers: headers });
        console.log('URL =>', this.processUrl);
        console.log('BODY =>', body);
        console.log('OPTIONS =>', options);

        return this.authHttp.post(this.processUrl, body, options)
            .map(this.extractData)
            .catch(this.handleError);
    }

    processingUploadCheck(): Observable<string> {
        console.log('processingUploadCheck service called');
        let body = JSON.stringify({ model: 1 });
        let headers = new Headers({
          'Content-Type': 'application/json'
        });
        let options = new RequestOptions({ body: body, headers: headers });

        return this.authHttp.post(this.processStatusUrl, body, options)
          .map(this.extractData)
          .catch(this.handleError);
    }

    handleError(error: any) {
    // In a real world app, we might use a remote logging infrastructure
    // We'd also dig deeper into the error to get a better message
    let errMsg = (error.message) ? error.message :
        error.status ? `${error.status} - ${error.statusText}` : 'Server error';
    console.error('CAUGHT AN ERROR:', errMsg); // log to console instead
    return Observable.throw(errMsg);
    }

    private extractData(res: Response) {
    let body = res.json();
    // console.log('BODY:', body);
    return body || {};
    }

    updateProject(id: number, updateProjectdetails: any): Observable<string> {
    let body = JSON.stringify({ project: updateProjectdetails });

    let headers = new Headers({
        'Content-Type': 'application/json'
    });
    let options = new RequestOptions({ headers: headers });

    return this.authHttp.put(this.projectsUrl + '/' + id, body, options)
        .map(this.extractData)
        .catch(this.handleError);
    }

}



// WEBPACK FOOTER //
// /Users/mark/Documents/Source/MachineResearch/MR2/angular2/src/app/uploadmodel/uploadmodel.service.ts